<div class="modal-header">
    <h5 class="modal-title">Duplicate Observation</h5>
    <button type="button" class="btn btn-info cancel" (click)="activeModal.dismiss('cancel')">
        <i class="fas fa-times"></i>
    </button>
</div>

<div class="modal-body">
    <form [formGroup]="form" (ngSubmit)="onSubmit(form)">
        <div *ngIf="showAdditionalOptionsSPM()" class="p-1">
            <div class="text-danger" *ngIf="showError('performanceMeasureType')">You must enter a valid performance measure type.</div>
            <label class="form-label" for="performanceMeasureType">Performance Measure Type <span class="required">*</span></label>
            <select class="form-select" formControlName="performanceMeasureType">
                <option *ngFor="let opt of filteredPerformanceMeasureTypes" [ngValue]="opt.value">{{opt.label}}</option>
            </select>
        </div>

        <div class="p-1">
            <div class="text-danger" *ngIf="showError('evaluator')">You must enter a valid Evaluator.</div>
            <label class="form-label" for="evalUserId">Select Evaluator <span class="required">*</span></label>
            <select class="form-select" formControlName="evalUserId">
                <option [defaultSelected]=true [ngValue]="null" disabled>Select One</option>
                <option *ngFor="let opt of evaluators" [value]="opt.value">{{opt.label}}</option>
            </select>
        </div>

        <div class="p-1">
            <div class="text-danger" *ngIf="showError('schoolYear')">You must enter a valid school year.</div>
            <label class="form-label" for="schoolYear">School Year <span class="required">*</span></label>
            <select class="form-select" formControlName="schoolYear">
                <option [defaultSelected]=true value="" disabled>Select One</option>
                <option *ngFor="let opt of schoolYears" [value]="opt">{{opt}}</option>
            </select>
        </div>

        <div class="text-end p-1">
            <button type="submit" class="btn btn-primary me-2" [disabled]="form.invalid" [ladda]="busy" (click)="onSubmit(form)">
                <i class="far fa-plus"></i> Duplicate Observation
            </button>
            <button type="button" class="btn btn-info m-2" [ladda]="busy" (click)="activeModal.close()">Cancel</button>
        </div>
    </form>
</div>

